export enum Metrics {
    AgingProgress = 'Aging Progress',
    DaysToComplete = 'Days To Complete',
    ScrubbingOutcomes = 'Scrubbing Outcomes',
    ScrubbingPerformanceTrend = 'Scrubbing Performance Trend',
    ScrubbingErrorsWarnings = 'Common Errors & Warnings',
    AgingStalledClaims = 'Stalled Claims',
}

export enum DaysToCompleteDateRangeOptions {
    Last90Days = 'LAST_90_DAYS',
    Last3Months = 'LAST_3_MONTHS',
    Last6Months = 'LAST_6_MONTHS',
    Last12Months = 'LAST_12_MONTHS',
    Custom = 'CUSTOM',
}

export enum ScrubbingOutcomesDateRangeOptions {
    CurrentMonth = 'CURRENT_MONTH',
    PreviousMonth = 'PREVIOUS_MONTH',
    Last3Months = 'LAST_3_MONTHS',
    Last6Months = 'LAST_6_MONTHS',
    Last12Months = 'LAST_12_MONTHS',
    Custom = 'CUSTOM',
}
